export default function PjCard07() {
    return (
        <div
            style={{
                position: "relative",
                zIndex: "10",
                width: "20em",
                maxWidth: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
            }}
        >
            <img
                src="/assets/projects/pd/tabletmockup.png"
                alt="PURE Design project mockup"
                loading="lazy"
                style={{
                    display: "block",
                    width: "50em",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "2em",
                }}
            />
        </div>
    );
}
